import React from 'react';
import PropTypes from 'prop-types';
import createEmotionStyled from 'create-emotion-styled';
import createEmotion from 'create-emotion';
import { withTheme } from 'emotion-theming';
var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context, {
  nonce: btoa('web-ui-components')
}),
    caches = _createEmotion.caches,
    css = _createEmotion.css,
    cx = _createEmotion.cx,
    flush = _createEmotion.flush,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    hydrate = _createEmotion.hydrate,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    merge = _createEmotion.merge,
    sheet = _createEmotion.sheet;

var emotion = /*#__PURE__*/Object.freeze({
  __proto__: null,
  caches: caches,
  css: css,
  cx: cx,
  flush: flush,
  getRegisteredStyles: getRegisteredStyles,
  hydrate: hydrate,
  injectGlobal: injectGlobal,
  keyframes: keyframes,
  merge: merge,
  sheet: sheet
});
var styled = createEmotionStyled(emotion, React);

var taggedTemplateLiteral = function taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var _templateObject = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tfont-family: ', ';\n\ttext-decoration: underline;\n\twhite-space: nowrap;\n'], ['\n\tcolor: ', ';\n\tfont-family: ', ';\n\ttext-decoration: underline;\n\twhite-space: nowrap;\n']);

var StyledLink = styled('a')(_templateObject, function (props) {
  return props.theme.colours.links;
}, function (props) {
  return props.theme.fonts.emailLink;
});
/**
 * Uses `<a>` tag internally, href is prefixed with "mailto &#58;"
 * @example ./Design.md
 */

var EmailLink = function EmailLink(_ref) {
  var email = _ref.email,
      linkText = _ref.linkText;
  return React.createElement(StyledLink, {
    href: 'mailto:' + email,
    linkText: linkText
  }, linkText || email);
};

EmailLink.propTypes = {
  /** Displayed text */
  linkText: PropTypes.string,

  /** Email address */
  email: PropTypes.string.isRequired
};
EmailLink.defaultProps = {};

EmailLink.defaultExample = function () {
  return React.createElement(EmailLink, {
    email: 'john.doe@email.com'
  });
};

var _templateObject$1 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tfont-family: ', ';\n\ttext-decoration: ', ';\n\twhite-space: nowrap;\n'], ['\n\tcolor: ', ';\n\tfont-family: ', ';\n\ttext-decoration: ', ';\n\twhite-space: nowrap;\n']);

var StyledLink$1 = styled('a')(_templateObject$1, function (props) {
  return props.theme.colours.links;
}, function (props) {
  return props.theme.fonts.emailLink;
}, function (props) {
  return props.theme.name === 'vm' ? 'none' : 'underline';
});
/**
 * Uses `<a>` tag internally, the href is prefixed with "tel:"
 * @example ./Design.md
 */

var PhoneLink = function PhoneLink(_ref) {
  var linkText = _ref.linkText,
      phoneNumber = _ref.phoneNumber;
  return React.createElement(StyledLink$1, {
    href: 'tel:' + phoneNumber,
    linkText: linkText
  }, linkText || phoneNumber);
};

PhoneLink.propTypes = {
  /** Displayed text */
  linkText: PropTypes.string,

  /** Phone Number */
  phoneNumber: PropTypes.string.isRequired
};
PhoneLink.defaultProps = {};

PhoneLink.defaultExample = function () {
  return React.createElement(PhoneLink, {
    phoneNumber: '0000 000 0000'
  });
};

var getThemeIcon = function getThemeIcon(vmIcon, generalIcon) {
  return function (themeName) {
    return themeName === 'vm' ? vmIcon : generalIcon;
  };
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var GenericIcon = function GenericIcon(_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    width: "96",
    height: "96",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("path", {
    d: "M95.802 3.212c0-.006.003-.013.003-.02l-.003-.018-.004-.176c0-.717-.31-1.347-.758-1.86-.057-.076-.099-.162-.166-.233-.067-.064-.157-.105-.234-.163C94.122.301 93.485 0 92.77.003h-.176L92.57 0c-.012 0-.022.006-.035.006L60.411.208c-1.67.006-3.016 1.443-3.007 3.212.003 1.77 1.363 3.196 3.033 3.19l24.48-.15-52.01 52.201a3.118 3.118 0 0 0 .02 4.422 3.147 3.147 0 0 0 4.44-.016l52.046-52.24.153 24.323c.01 1.667 1.453 3.01 3.232 2.998 1.775-.007 3.212-1.357 3.202-3.02l-.198-31.916zM83.18 86.348a3.2 3.2 0 0 1-3.2 3.2H9.598a3.2 3.2 0 0 1-3.2-3.2V15.964a3.2 3.2 0 0 1 3.2-3.199h41.59V6.367H6.398A6.4 6.4 0 0 0 0 12.765v76.782a6.4 6.4 0 0 0 6.399 6.399H83.18a6.399 6.399 0 0 0 6.398-6.399v-44.79h-6.398v41.59z"
  }));
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties$1(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var VMIcon = function VMIcon(_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1(_ref, ["styles"]);

  return React.createElement("svg", _extends$1({
    height: "96",
    viewBox: "0 0 96 96",
    width: "96",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("path", {
    d: "M36.888 4.096v8H8.336v71.996h72v-32h8v40h-88V4.096zM92.464.364v24h-8l-.001-10.344-20.201 20.203a44.03 44.03 0 0 1-11.88 8.338A80.542 80.542 0 0 1 56 67.266V76h-8v-8.734A73.774 73.774 0 0 0 44.969 45.5a61.199 61.199 0 0 1-11.586 2.414 13.904 13.904 0 0 1-11.445-4.016l-.297-.33c-4.983-5.435-4.998-13.773-.036-19.226l.29-.32c5.471-5.46 14.329-5.46 19.8 0a41.831 41.831 0 0 1 7.7 11.1 35.775 35.775 0 0 0 9.21-6.556L78.807 8.364H68.464v-8zM27.695 29.537a6.278 6.278 0 0 0 .047 8.848 5.953 5.953 0 0 0 4.758 1.578 53.648 53.648 0 0 0 9.48-1.908 32.764 32.764 0 0 0-5.773-8.211 6.08 6.08 0 0 0-8.512-.307z"
  }));
};

var getPopoutOutlineLarge = getThemeIcon(VMIcon, GenericIcon);

var _templateObject$2 = taggedTemplateLiteral(['\n\tmargin-left: ', ';\n\t> svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\twidth: ', ';\n\t}\n'], ['\n\tmargin-left: ', ';\n\t> svg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\twidth: ', ';\n\t}\n']),
    _templateObject2 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tdisplay: inline-flex;\n\ttext-decoration: underline;\n\twhite-space: nowrap;\n'], ['\n\tcolor: ', ';\n\tdisplay: inline-flex;\n\ttext-decoration: underline;\n\twhite-space: nowrap;\n']);

var StyledIcon = styled('div')(_templateObject$2, function (props) {
  return props.theme.isCompact ? '2px' : '4px';
}, function (props) {
  return props.theme.colours.links;
}, function (props) {
  return props.theme.isCompact ? '8px' : '16px';
}, function (props) {
  return props.theme.isCompact ? '8px' : '16px';
});
var StyledLink$2 = styled('a')(_templateObject2, function (props) {
  return props.theme.colours.links;
});
/**
 * When willOpenNewWindow is true `<a>` tag will have `rel = noopener noreferrer`.
 * @example ./Design.md
 */
// eslint-disable-next-line react/prop-types

var WebsiteLink = function WebsiteLink(_ref) {
  var linkText = _ref.linkText,
      linkTitle = _ref.linkTitle,
      theme = _ref.theme,
      url = _ref.url,
      willOpenNewWindow = _ref.willOpenNewWindow;
  var target = willOpenNewWindow ? '_blank' : '_self';
  var PopoutIcon = getPopoutOutlineLarge(theme.name);
  return React.createElement(StyledLink$2, {
    href: '' + url,
    target: target,
    title: linkTitle,
    rel: willOpenNewWindow ? 'noopener noreferrer' : null
  }, linkText || url, willOpenNewWindow && React.createElement(StyledIcon, null, React.createElement(PopoutIcon, null)));
};

WebsiteLink.propTypes = {
  /** Displayed text */
  linkText: PropTypes.string,

  /** Native 'a' title attribute text */
  linkTitle: PropTypes.string,

  /** Website url */
  url: PropTypes.string.isRequired,

  /* Opens link in a new tab or window when clicked */
  willOpenNewWindow: PropTypes.bool
};
WebsiteLink.defaultProps = {
  willOpenNewWindow: false
};
var WrappedWebsiteLink = withTheme(WebsiteLink);

WrappedWebsiteLink.defaultExample = function () {
  return React.createElement(WrappedWebsiteLink, {
    url: 'https://uk.virginmoney.com/'
  });
};

export { EmailLink, PhoneLink, WrappedWebsiteLink as WebsiteLink };